import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import Alert from "./Alert";
import MainContent from "./MainContent";
import SmartLookup from "./SmartLookup";
import ContactHelp from "./ContactHelp";
import {FadeUp, FadeInAndShrink} from "./AnimationLibrary";

const TellUsWhoYouAre = props => {
	const [selected, setSelected] = useState(false);
	const [alertState, setAlertState] = useState({});

	const handleCloseAlert = () => {
		setAlertState({});
	};

	const onUserSelected = user => {
		props.setUser(user);
		setSelected(true);
	};

	if (selected) return <Redirect push from="telluswhoyouare" to="/selectverificationoption" />;

	return (
		<>
			{alertState.message && <Alert {...alertState} close={handleCloseAlert} />}
			<FadeInAndShrink>
				<MainContent>
					<FadeUp delay="250">
						<IntroText pwReset={props.pwReset} />
					</FadeUp>
					<div className="heading-container mt-1r">
						<FadeUp delay="350">
							<h3>Tell us who you are:</h3>
							<SmartLookup setUser={onUserSelected} apiService={props.apiService} setAlertState={setAlertState}/>
						</FadeUp>
				</div>
				</MainContent>
				<ContactHelp delay="450" />
			</FadeInAndShrink>
		</>
	);
};

const IntroText = props => {
	var heading;
	var detail;
	if (props.pwReset) {
		heading = "Password Recovery";
		detail = "Let's find your account so we can help you manage your password. We'll need to verify your identity before resetting or updating your password.";
	} else {
		heading = "Account Setup";
		detail = "You’ll use one account for Dartmouth’s online services. Let's find your account so we can help you secure and begin using your account.";
	}

	return (
		<div className="intro-text">
			<h2 className="intro__heading">{heading}</h2>
			<p className="intro__p">
				{detail}
			</p>
		</div>
	);
};

export default TellUsWhoYouAre;
